// Helpers
import Helpers from '.';

// Helpers
import Config from '../config';

// UUID
import uuid from 'react-native-uuid';

// Mobx
import LanguageStore from "../mobx/stores/LanguageStore";
import StoreStore from '../mobx/stores/StoreStore';
import CurrencyStore from "../mobx/stores/CurrencyStore";

const differentNowDate = (date: any) => {
    const nowDate: any = new Date();
    date = new Date(date);

    let leftSec: any = "";

    var diff = (date - nowDate) / 1000;
    diff = Math.abs(Math.floor(diff));

    var days = Math.floor(diff / (24 * 60 * 60));
    leftSec = diff - days * 24 * 60 * 60;

    var hrs = Math.floor(leftSec / (60 * 60));
    leftSec = leftSec - hrs * 60 * 60;

    var min = Math.floor(leftSec / (60));
    leftSec = leftSec - min * 60;

    return {
        days,
        hrs,
        min,
    }
}

const convertElapsedTime = (date: any) => {
    const convertDate = Helpers.differentNowDate(date);

    let dateData: any = {
        type: '',
        variable: 0,
        now: false
    };

    if (convertDate.min === 0) {
        dateData = {
            type: 'minute',
            variable: convertDate.min,
            now: true,
            text: Helpers.translation('now')
        }
    }
    if (convertDate.min > 0) {
        dateData = {
            type: 'minute',
            variable: convertDate.min,
            now: false,
            text: Helpers.translationParams('date/minute_ago', { minute: convertDate.min })
        }
    }
    if (convertDate.hrs > 0) {
        dateData = {
            type: 'hours',
            variable: convertDate.hrs,
            now: false,
            text: Helpers.translationParams('date/hour_ago', { hour: convertDate.hrs })
        }
    }
    if (convertDate.days > 0) {
        dateData = {
            type: 'days',
            variable: convertDate.days,
            now: false,
            text: Helpers.translationParams('date/day_ago', { day: convertDate.days })
        }
    }

    return dateData;
}

const arraySort = (array: any, key: string, type: any = 'normal') => {
    return array.slice().sort(function (a: any, b: any) {
        if (type === 'normal') {
            return parseInt(a[key]) - parseInt(b[key]);
        } else if (type === 'datetime') {
            const bDate: any = new Date(b[key]);
            const aDate: any = new Date(a[key]);

            return bDate - aDate;
        } else {
            return [];
        }
    });
}

const ToSeoString = (string: any) => {
    return string.toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase()
        .replace(/&/g, '-and-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-*/, '')
        .replace(/-*$/, '')
}

const countProperties = (obj: string[]) => {
    return Object.keys(obj).length;
}

const findIndexObjectInArray = (object: any, prop: any, key: string | number) => {
    return object.findIndex((search: string) => search[prop] === key);
}

const explodeDate = (date: Date) => {
    const languageCode = LanguageStore.languageData.currentLanguage;

    let convertDate = new Date(date);

    let returnDate = convertDate.toLocaleDateString(languageCode, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    let returnTime = convertDate.toLocaleString().split(' ')[1];

    return {
        date: returnDate,
        time: returnTime,
        dateTime: returnDate + ' - ' + returnTime
    }
}

const objectToArray = (object: any) => {
    return Object.keys(object).map(function (key) {
        return object[key];
    });
}

const getSmallestImageUrl = (imageData: any) => {
    let returnUrl = '';
    const formats = imageData.formats;

    if (formats !== null) {
        if (formats.large !== undefined) {
            returnUrl = formats.large.url;
        }

        if (formats.medium !== undefined) {
            returnUrl = formats.medium.url;
        }

        if (formats.small !== undefined) {
            returnUrl = formats.small.url;
        }

        if (formats.thumbnail !== undefined) {
            returnUrl = formats.thumbnail.url;
        }
    } else {
        returnUrl = imageData.url;
    }

    return Config.App.baseUrl + returnUrl;
}

const getMediumImageUrl = (imageData: any) => {
    let returnUrl = '';
    const formats = imageData.formats;

    if (formats !== null) {
        if (formats.thumbnail !== undefined) {
            returnUrl = formats.thumbnail.url;
        }

        if (formats.small !== undefined) {
            returnUrl = formats.small.url;
        }

        if (formats.medium !== undefined) {
            returnUrl = formats.medium.url;
        }
    } else {
        returnUrl = imageData.url;
    }

    return Config.App.baseUrl + returnUrl;
}

const getBiggestImageUrl = (imageData: any) => {
    let returnUrl = '';
    const formats = imageData.formats;

    if (formats !== null) {
        if (formats.thumbnail !== undefined) {
            returnUrl = formats.thumbnail.url;
        }

        if (formats.small !== undefined) {
            returnUrl = formats.small.url;
        }

        if (formats.medium !== undefined) {
            returnUrl = formats.medium.url;
        }

        if (formats.large !== undefined) {
            returnUrl = formats.large.url;
        }
    } else {
        returnUrl = imageData.url;
    }

    return Config.App.baseUrl + returnUrl;
}

const randomUniq = () => {
    const uniq: any = uuid.v4();
    const split = uniq.split('-');

    return split[split.length - 1];
}

const findAndProcessDuplicates = async (ids) => {
    const indexMap = {};
    const duplicates: any = [];

    for (let i = 0; i < ids.length; i++) {
        const value = ids[i];

        // Asenkron işlemi bekliyoruz (örneğin, bir API çağrısı gibi)
        await new Promise(resolve => setTimeout(resolve, 100));

        if (indexMap[value] === undefined) {
            indexMap[value] = [i];
        } else {
            indexMap[value].push(i);

            if (indexMap[value].length === 2) {
                duplicates.push({ id: value, indexes: [...indexMap[value]] });
            } else if (indexMap[value].length > 2) {
                const lastDuplicate = duplicates.find(dup => dup.id === value);
                if (lastDuplicate) lastDuplicate.indexes.push(i);
            }
        }
    }

    return duplicates;
};

const generateOtpCode = () => {
    var digits = '0123456789';
    let OTP = '';
    for (let i = 0; i < 6; i++) {
        OTP += digits[Math.floor(Math.random() * 10)];
    }
    return OTP;
};

const findIndexByCriteria = (array: any, key: string, value: any) => {
    const index = array.findIndex((obj: any) => obj[key] === value);
    return index !== -1 ? index : -1;
};

const truncateText = (text: any, maxLength: any) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + "...";
    }
    return text; // Metin belirtilen uzunlukta veya daha kısa ise olduğu gibi döner
}

const returnMenuLink = (menuData: any, type: string = "main") => {
    let returnLink = menuData.link;

    if (menuData.relation_type !== null) {
        let relation = menuData[menuData.relation_type];

        if (menuData.relation_type === "product_category") {
            if (relation.data !== null) {
                returnLink = "/products/category/" + relation.data.id
            }
        }

        if (menuData.relation_type === "products") {
            returnLink = "/products"
        }

        if (menuData.relation_type === "payment") {
            returnLink = Helpers.getSettings().payment_url
        }

        if (menuData.relation_type === "page") {
            if (relation.data !== null) {
                returnLink = "/" + relation.data.attributes.slug
            }
        }

        if (menuData.relation_type === "logout") {
            returnLink = "/logout"
        }

        if (menuData.relation_type === "login") {
            returnLink = "/login"
        }

        if (menuData.relation_type === "homepage") {
            returnLink = "/home"
        }

        if (menuData.relation_type === "select_store") {
            returnLink = "/"
        }

        if (menuData.relation_type === "profile") {
            returnLink = "/profile"
        }

        if (menuData.relation_type === "guarantee") {
            returnLink = "/documents"
        }

        if (menuData.relation_type === "orders") {
            returnLink = "/orders"
        }

        if (menuData.relation_type === "payment_notifications") {
            returnLink = "/paymentnotifications"
        }
    }

    return {
        newTab: menuData.new_tab,
        returnLink
    }
}

const returnPrice = (productId: number, productCurrencyData: any, count: number = 0) => {
    const storeId: any = localStorage.getItem('storeId');
    let currentCurrencyData: any = null;
    let convert = true;
    let returnData: any = null;

    let discountAmount: number = 0;
    let discountStatus: boolean = false;

    if (Helpers.getUserData().discount_amount !== null && Helpers.getUserData().discount_amount > 0) {
        discountStatus = true;
        discountAmount = parseInt(Helpers.getUserData().discount_amount);
    }

    const productDiscountIndex = Helpers.getUserData().discounted_product_datas !== null ? Helpers.findIndexByCriteria(Helpers.getUserData().discounted_product_datas, "product_id", productId) : -1;
    if (productDiscountIndex !== -1) {
        discountStatus = true;
        discountAmount = parseInt(Helpers.getUserData().discounted_product_datas[productDiscountIndex].discount);
    }

    if (Helpers.getUserData().currency !== null) {
        currentCurrencyData = convertCurrencyData(Helpers.getUserData().currency);
    } else {
        currentCurrencyData = convertCurrencyData(StoreStore.stores[storeId].currency);
    }

    if (productCurrencyData.id === currentCurrencyData.id) {
        convert = false;

        let price = productCurrencyData.price;

        let discountPrice = 0;
        if (discountStatus) {
            discountPrice = (price * discountAmount) / 100
            discountPrice = multiplyStringNumber(price - discountPrice, 1)
        }

        returnData = {
            withSymbol: price + '' + currentCurrencyData.symbol,
            onlyPrice: price,
            discountPriceWithSymbol: discountPrice + '' + currentCurrencyData.symbol,
            discountPrice: discountPrice,
            symbol: currentCurrencyData.symbol,
            currentCurrencyData
        }
    } else {
        const currencyStoreData = CurrencyStore.currencies[productCurrencyData.id];

        if (currencyStoreData !== undefined) {
            const valueIndex = Helpers.findIndexByCriteria(currencyStoreData.current_transaction.data.attributes.currencies, "id", currentCurrencyData.id);
            const valueData = currencyStoreData.current_transaction.data.attributes.currencies[valueIndex];

            let price = multiplyStringNumber(valueData.value, productCurrencyData.price);

            let discountPrice = 0;
            if (discountStatus) {
                discountPrice = (price * discountAmount) / 100
                discountPrice = multiplyStringNumber(price - discountPrice, 1)
            }

            returnData = {
                withSymbol: price + '' + currentCurrencyData.symbol,
                onlyPrice: price,
                discountPriceWithSymbol: discountPrice + '' + currentCurrencyData.symbol,
                discountPrice: discountPrice,
                symbol: currentCurrencyData.symbol,
                currentCurrencyData
            };
        }
    }

    if (count > 0) {
        let shoppigCardPrice = returnData.onlyPrice * count;
        let shoppigCardDiscountPrice = returnData.discountPrice * count;

        returnData = {
            withSymbol: shoppigCardPrice + '' + currentCurrencyData.symbol,
            onlyPrice: shoppigCardPrice,
            discountPriceWithSymbol: shoppigCardDiscountPrice + '' + currentCurrencyData.symbol,
            discountPrice: shoppigCardDiscountPrice,
            symbol: currentCurrencyData.symbol,
            currentCurrencyData
        }
    }

    return returnData;
}

const convertCurrencyData = (currencyData: any) => {
    if (currencyData.data !== undefined) {
        if (currencyData.data !== null) {
            let newCurrencyData = {
                id: currencyData.data.id,
                ...currencyData.data.attributes,
                value: {
                    id: currencyData.data.attributes.current_transaction.data.id,
                    ...currencyData.data.attributes.current_transaction.data.attributes
                }
            }
            delete newCurrencyData.current_transaction;

            return newCurrencyData;
        } else {
            return null;
        }
    } else {
        let newCurrencyData = {
            ...currencyData,
            value: {
                ...currencyData.current_transaction
            }
        };
        delete newCurrencyData.current_transaction;

        return newCurrencyData;
    }
}

const multiplyStringNumber = (stringNumber: string | number, multiplier: number): number => {
    let numericValue: number;

    // Eğer stringNumber bir sayıysa doğrudan ata
    if (typeof stringNumber === "number") {
        numericValue = stringNumber;
    }
    // Eğer stringNumber bir string ise virgülü noktaya çevirerek sayıya dönüştür
    else if (typeof stringNumber === "string") {
        numericValue = parseFloat(stringNumber.replace(",", "."));
    } else {
        throw new Error("Geçerli bir sayı veya string girin!");
    }

    if (isNaN(numericValue)) {
        throw new Error("Geçerli bir sayı girin!"); // Hata mesajı
    }

    // Eğer sayı tam sayıysa doğrudan döndür
    if (Number.isInteger(numericValue)) {
        return numericValue;
    }

    // Eğer float ise çarp ve sonucu 2 ondalık basamakta yuvarla
    const returnData = numericValue * multiplier;
    return Math.round(returnData * 100) / 100; // Sayıyı 2 basamağa yuvarla ve döndür
};

const menuVisibleStatus = (visible: any) => {
    const isUserLoggedIn = Helpers.getUserData().isLogin;

    if (visible === "login" && isUserLoggedIn) return true;  // Giriş yapmış kullanıcılar için
    if (visible === "not_login" && !isUserLoggedIn) return true; // Giriş yapmamış kullanıcılar için
    if (visible === "all" || visible === null || visible === undefined) return true; // Herkes için görünür
    
    return false;
}

const buildPopulateParams = (obj: any, prefix = 'populate') => {
    const params: any = [];

    for (const key in obj) {
        const value = obj[key];

        if (value === true || value === '*') {
            params.push(`${prefix}[${key}]=${value}`);
        } else if (typeof value === 'object' && value.populate) {
            const nested = buildPopulateParams(value.populate, `${prefix}[${key}][populate]`);
            params.push(nested);
        }
    }

    return params.flat().join('&');
}

const exportHelpers = {
    differentNowDate,
    explodeDate,
    ToSeoString,
    countProperties,
    findIndexObjectInArray,
    arraySort,
    convertElapsedTime,
    objectToArray,
    getSmallestImageUrl,
    getMediumImageUrl,
    getBiggestImageUrl,
    randomUniq,
    findAndProcessDuplicates,
    generateOtpCode,
    findIndexByCriteria,
    truncateText,
    returnMenuLink,
    returnPrice,
    convertCurrencyData,
    multiplyStringNumber,
    menuVisibleStatus,
    buildPopulateParams
};

export default exportHelpers;